import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import PhoneNumberField from '../components/PhoneNumberField';
import emailjs from '@emailjs/browser';
import { formatPhoneWithCountryCode, getIndianPhoneError } from '../utils/phoneUtils';

const Services = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [country, setCountry] = useState('in');
    const [countryCode, setCountryCode] = useState('+91');
    const [phoneError, setPhoneError] = useState('');
    const [alertMessage, setAlertMessage] = useState({ text: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    const handlePhoneChange = (digits) => {
        setFormData(prevState => ({ ...prevState, phone: digits }));
        setPhoneError(getIndianPhoneError(digits, countryCode));
    };

    const handleCountryCodeChange = ({ countryIso, countryCode: dialCode }) => {
        setCountry(countryIso || 'in');
        setCountryCode(dialCode || '+91');
        setPhoneError(getIndianPhoneError(formData.phone, dialCode || '+91'));
    }; 

    const sendEmail = (e) => {
        e.preventDefault();
        console.log("sendEmail function called");
        console.log("Form data:", formData);

        // Trim all values
        const trimmedData = {
            name: formData.name.trim(),
            email: formData.email.trim(),
            phone: formData.phone.trim(),
            subject: formData.subject.trim(),
            message: formData.message.trim()
        };

        const phoneValidation = getIndianPhoneError(trimmedData.phone);

        if (!trimmedData.name || !trimmedData.email || !trimmedData.phone || !trimmedData.subject || !trimmedData.message) {
            console.log("Validation failed - missing fields");
            setPhoneError(phoneValidation);
            setAlertMessage({ text: "Please fill in all fields.", type: 'error' });
            return;
        }

        if (phoneValidation) {
            console.log("Validation failed - phone error", phoneValidation);
            setPhoneError(phoneValidation);
            setAlertMessage({ text: phoneValidation, type: 'error' });
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(trimmedData.email)) {
            console.log("Invalid email format");
            setAlertMessage({ text: "Please enter a valid email address.", type: 'error' });
            return;
        }

        setIsLoading(true);
        console.log("Sending email with data:", trimmedData);
        console.log("Service ID: service_v6l9rbv, Template ID: template_zja3scs");

        const submissionData = {
            ...trimmedData,
            phone: formatPhoneWithCountryCode(countryCode, trimmedData.phone)
        };

        emailjs.send("service_v6l9rbv", "template_zja3scs", submissionData)
            .then((response) => {
                console.log("✅ SUCCESS! Response:", response);
                setAlertMessage({ text: "Your message has been sent successfully!", type: 'success' });
                setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("❌ FAILED! Error:", error);
                let errorMsg = "Something went wrong. Please try again later.";
                if (error.text) {
                    errorMsg += " " + error.text;
                }
                setAlertMessage({ text: errorMsg, type: 'error' });
                setIsLoading(false);
            });
    };

    useEffect(() => {
        emailjs.init("GPGBbocMM4O1llkd1");
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">Services</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/service">Pages</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Services</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* Service Start */}
            <div className="container-xxl service py-5">
                <div className="container">
                    <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                        <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Our Services</p>
                        <h1 className="display-5 mb-5">Our Awsome Services</h1>
                    </div>
                    <div className="row g-4 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="col-lg-4">
                            <div className="nav nav-pills d-flex justify-content-between w-100 h-100 me-4">
                                <button className="nav-link w-100 d-flex align-items-center text-start border p-4 mb-4 active"
                                    data-bs-toggle="pill" data-bs-target="#tab-pane-1" type="button">
                                    <h5 className="m-0"><i className="fa-solid fa-code text-primary me-3"></i>Web Developing</h5>
                                </button>
                                <button className="nav-link w-100 d-flex align-items-center text-start border p-4 mb-4"
                                    data-bs-toggle="pill" data-bs-target="#tab-pane-2" type="button">
                                    <h5 className="m-0"><i className="fa-solid fa-cart-shopping text-primary me-3"></i>E-Commerce</h5>
                                </button>
                                <button className="nav-link w-100 d-flex align-items-center text-start border p-4 mb-4"
                                    data-bs-toggle="pill" data-bs-target="#tab-pane-3" type="button">
                                    <h5 className="m-0"><i className="fa-solid fa-users text-primary me-3"></i>Social Media Presence</h5>
                                </button>
                                <button className="nav-link w-100 d-flex align-items-center text-start border p-4 mb-0"
                                    data-bs-toggle="pill" data-bs-target="#tab-pane-4" type="button">
                                    <h5 className="m-0"><i className="fas fa-user-check text-primary me-3"></i>IT Consulting</h5>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="tab-content w-100">
                                <div className="tab-pane fade show active" id="tab-pane-1">
                                    <div className="row g-4">
                                        <div className="col-md-6" style={{ minHeight: '350px' }}>
                                            <div className="position-relative h-100">
                                                <img className="position-absolute rounded w-100 h-100" src="img/images/developing.png"
                                                    style={{ objectFit: 'cover' }} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h3 className="mb-4">Web Development</h3>
                                            <p className="mb-4">Crafting innovative websites tailored to your unique needs, ensuring a user-friendly experience and high-impact online presence.</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Cutting-edge websites</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Custom solutions</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Seamless user experiences</p>
                                            <a href="/contact" className="btn btn-primary py-3 px-5 mt-3">Let's Start</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="tab-pane-2">
                                    <div className="row g-4">
                                        <div className="col-md-6" style={{ minHeight: '350px' }}>
                                            <div className="position-relative h-100">
                                                <img className="position-absolute rounded w-100 h-100" src="img/images/e-commerce.png"
                                                    style={{ objectFit: 'cover' }} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h3 className="mb-4">Ecommerce</h3>
                                            <p className="mb-4">We specialize in creating profitable online stores, integrating secure payment systems, and driving sales growth for your business.</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Online store expertise</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Payment integration</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Boosted sales and growth</p>
                                            <a href="/contact" className="btn btn-primary py-3 px-5 mt-3">Let's Start</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="tab-pane-3">
                                    <div className="row g-4">
                                        <div className="col-md-6" style={{ minHeight: '350px' }}>
                                            <div className="position-relative h-100">
                                                <img className="position-absolute rounded w-100 h-100" src="img/images/social-media.png"
                                                    style={{ objectFit: 'cover' }} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h3 className="mb-4">Social Media Presence</h3>
                                            <p className="mb-4">Our experts enhance your brand's visibility with compelling content, expanding your reach and engaging your target audience effectively.</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Engaging content</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Expanded reach</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Brand visibility</p>
                                            <a href="/contact" className="btn btn-primary py-3 px-5 mt-3">Let's Start</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="tab-pane-4">
                                    <div className="row g-4">
                                        <div className="col-md-6" style={{ minHeight: '350px' }}>
                                            <div className="position-relative h-100">
                                                <img className="position-absolute rounded w-100 h-100" src="img/images/consulting.png"
                                                    style={{ objectFit: 'cover' }} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <h3 className="mb-4">IT Consulting</h3>
                                            <p className="mb-4">We provide strategic technology guidance, optimizing efficiency, and fortifying your cybersecurity measures for sustainable business growth.</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Strategic tech guidance</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Efficiency improvements</p>
                                            <p><i className="fa fa-check text-primary me-3"></i>Enhanced cybersecurity</p>
                                            <a href="/contact" className="btn btn-primary py-3 px-5 mt-3">Let's Start</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Service End */}

            {/* contactUs Start */}
            <div className="container-fluid contactUs my-5 pt-5">
                <div className="container pt-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div className="bg-white border rounded p-4 p-sm-5 wow fadeInUp" data-wow-delay="0.5s">
                                <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                                    <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Get In Touch</p>
                                    <h1 className="display-5 mb-5">If You Have Any Query, Please Contact Us</h1>
                                </div>
                                <form id="contact" onSubmit={sendEmail}>
                                    {alertMessage.text && (
                                        <div style={{
                                            backgroundColor: alertMessage.type === 'success' ? "#d4edda" : "#f8d7da",
                                            color: alertMessage.type === 'success' ? "#155724" : "#721c24",
                                            border: alertMessage.type === 'success' ? "1px solid #c3e6cb" : "1px solid #f5c6cb",
                                            padding: "10px 15px",
                                            borderRadius: "4px",
                                            marginBottom: "20px"
                                        }}>
                                            {alertMessage.text}
                                        </div>
                                    )}
                                    <div className="row g-3">
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    id="name" 
                                                    placeholder="Your Name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required 
                                                />
                                                <label htmlFor="name">Your Name</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input 
                                                    type="email" 
                                                    className="form-control" 
                                                    id="email"
                                                    placeholder="Your Email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required 
                                                />
                                                <label htmlFor="email">Your Email</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <PhoneNumberField
                                                phone={formData.phone}
                                                country={country}
                                                countryCode={countryCode}
                                                onPhoneChange={handlePhoneChange}
                                                onCountryChange={handleCountryCodeChange}
                                                error={phoneError}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-floating">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    id="subject" 
                                                    placeholder="Subject"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    required 
                                                />
                                                <label htmlFor="subject">Subject</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-floating">
                                                <textarea 
                                                    className="form-control" 
                                                    placeholder="Leave a message here"
                                                    id="message" 
                                                    style={{ height: '100px' }}
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                                <label htmlFor="message">Message</label>
                                            </div>
                                        </div>
                                        <div className="col-12 text-center">
                                            <button 
                                                className="btn btn-primary w-100 py-3" 
                                                type="submit" 
                                                id="form-submit"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? "Sending..." : "Submit Now"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* contactUs End */}

            <Footer />
        </>
    );
};

export default Services;
